var FabricMimeTypes = /* @__PURE__ */ function(FabricMimeTypes2) {
  FabricMimeTypes2["VND_FABRIC_FOLDER"] = "application/vnd.fabric.folder";
  FabricMimeTypes2["VND_FABRIC_NOTEPAD"] = "application/vnd.fabric.notepad";
  FabricMimeTypes2["VND_FABRIC_BOOKMARK"] = "application/vnd.fabric.bookmark";
  FabricMimeTypes2["VND_FABRIC_HIGHLIGHT"] = "application/vnd.fabric.highlight";
  return FabricMimeTypes2;
}({});
var ViewTypes = /* @__PURE__ */ function(ViewTypes2) {
  ViewTypes2["Everything"] = "Inbox";
  ViewTypes2["Space"] = "Space";
  return ViewTypes2;
}({});
const EverythingModes = [
  "Grid",
  "List"
];
const SpaceModes = [
  "Kanban",
  "Masonry"
];
const SearchModes = [
  "Detailed"
];
const spaceViewModes = [
  ...SpaceModes,
  ...EverythingModes
];
const ViewMode = [
  ...EverythingModes,
  ...SpaceModes,
  ...SearchModes
];

export { EverythingModes, FabricMimeTypes, SearchModes, SpaceModes, ViewMode, ViewTypes, spaceViewModes };
//# sourceMappingURL=index.js.map
